import { hash } from '@ember/helper';

import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { or } from 'ember-truth-helpers';

import Avatar from 'umg-ember-backend/components/ui/avatar';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

<template>
  <div
    class={{bem (hash has-status=(or @record.hasError @record.cmsLockerId))}}
  >
    {{#if @record.hasError}}
      <div class={{bem 'error-indicator'}}>
        {{svgJar
          'error'
          class=(bem 'error-icon')
          aria-hidden='true'
          focusable='false'
          data-test-row-status-icon='error'
        }}
        <EmberTooltip @text={{@record.error}} @side='right' />
      </div>
    {{/if}}
    {{#if @record.cmsLockerId}}
      <Avatar
        @user={{@record.cmsLockerId}}
        @style='active'
        @tooltip={{t
          'record_explorer.table.td.locked_message'
          locker=@record.cmsLockerId.displayHeadline
        }}
        @tooltipSide='right'
      />
    {{/if}}
  </div>
</template>
